import apiBase from "./axios/apiBase";

const controller = "Parameters";

export async function getParameterByKey(key) {
  return apiBase.get(`/${controller}/bykey/${key}`);
}

export async function updateParameter(model) {
  return apiBase.put(`/${controller}/update`, model);
}
